module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/industry-06-6fcbfee54ef48ad688e589416b7b6900.png";